import { render, staticRenderFns } from "./UjoTrackingReport.vue?vue&type=template&id=0dfa1ca3&"
import script from "./UjoTrackingReport.vue?vue&type=script&lang=ts&"
export * from "./UjoTrackingReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dfa1ca3')) {
      api.createRecord('0dfa1ca3', component.options)
    } else {
      api.reload('0dfa1ca3', component.options)
    }
    module.hot.accept("./UjoTrackingReport.vue?vue&type=template&id=0dfa1ca3&", function () {
      api.rerender('0dfa1ca3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trucking/reports/UjoTrackingReport.vue"
export default component.exports